import { render, staticRenderFns } from "./VxTextarea.vue?vue&type=template&id=6de2ac4a&scoped=true"
import script from "./VxTextarea.vue?vue&type=script&lang=js"
export * from "./VxTextarea.vue?vue&type=script&lang=js"
import style0 from "./VxTextarea.vue?vue&type=style&index=0&id=6de2ac4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de2ac4a",
  null
  
)

export default component.exports